import Vue from 'vue';
import Router from 'vue-router';
import About from '@/components/about/about.vue';
import Blog from '@/components/blog/blog.vue';
import Join from '@/components/join/join.vue';
import Manage from '@/components/manage/manage.vue';
import Comments from '@/components/comments/comments.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import Create from '@/components/create/create.vue';
import Error404 from '@/components/404/404.vue';

Vue.use(Router);
export default new Router({
    mode: 'history',
    scrollBehavior(to, from) {
        if (to.name == null || from.name == null) {
            return null;
        } else {
            // return { x: 0, y: 0 };
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({ x: 0, y: 0 });
                }, 260);
            });
        }
    },
    routes: [
        {
            path: '/',
            name: 'About',
            component: About
        },
        {
            path: '/manage',
            name: 'Manage',
            component: Manage,
            children: [
                { path: 'comments', name: 'Comments', component: Comments },
                { path: 'create', name: 'Create', component: Create }
            ]
        },
        {
            path: '/join',
            name: 'Join',
            component: Join,
            meta: { scrollToTop: true }
        },
        {
            path: '/blog',
            children: [{ path: ':post', component: Blog, props: true }],
            name: 'Blog',
            props: true,
            component: Blog
        },
        {
            path: '/privacy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '*',
            name: 'Error404',
            component: Error404
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js